import { render, staticRenderFns } from "./TabPanes.vue?vue&type=template&id=44c95052&"
import script from "./TabPanes.vue?vue&type=script&lang=js&"
export * from "./TabPanes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports